import { createIcon } from "@chakra-ui/react";

export const Attentive = createIcon({
  displayName: "Attentive",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#zmqpledgca)">
      <path
        fill="currentColor"
        d="M19.5 15.129V10.75a4.373 4.373 0 0 0-4.375-4.375 4.373 4.373 0 0 0-4.375 4.375 4.373 4.373 0 0 0 4.375 4.375 4.369 4.369 0 0 0 3.125-1.313v3.38A8.124 8.124 0 0 1 3.875 12a8.124 8.124 0 0 1 10.016-7.903c-.27.109-.52.257-.75.437l-.907.727a.626.626 0 0 0 .782.976l.906-.726a1.768 1.768 0 0 1 2.082-.09l.336.223a.623.623 0 0 0 .71-.012A8.104 8.104 0 0 1 20.126 12c0 1.11-.223 2.168-.625 3.129zm.152 3.309A9.955 9.955 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c2.57 0 4.918-.969 6.688-2.566a4.984 4.984 0 0 0 1.91 2.191l.445.277a.625.625 0 0 0 .66-1.058l-.445-.278a3.769 3.769 0 0 1-1.613-2.128h.007zM12 10.75a3.125 3.125 0 1 1 6.25 0 3.125 3.125 0 0 1-6.25 0zM8.89 9.5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zm5.626 2.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-6.891 3.75c0 .344.281.625.625.625.559 0 1.48.113 2.367.457.89.344 1.668.887 2.074 1.695a.63.63 0 0 0 .84.282.629.629 0 0 0 .281-.84c-.597-1.192-1.69-1.899-2.738-2.305a8.379 8.379 0 0 0-2.824-.539.627.627 0 0 0-.625.625z"
      />
    </g>,
    <defs>
      <clipPath id="zmqpledgca">
        <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  ],
  defaultProps: {
    "aria-label": "Face with monocle emoji"
  }
});

export default Attentive;
